import { get, post, BaseUrl } from './api'

export const getTextLibraryGroups = async (startParameter) => {
  return await get(`api/TextLibrary/groups/${startParameter}`, window._env_?.REACT_APP_API_BASE_URL);
}

export const getTextLibraryLanguages = async () => {
  return await get(`api/TextLibrary/languages`, window._env_?.REACT_APP_API_BASE_URL);
}

export const searchTextLibrary = async (searchModel) => {
  return await post(`api/TextLibrary/search`, window._env_?.REACT_APP_API_BASE_URL, searchModel);
}

export const getTextForCode = async (startParam,code, lang) => {
  return await get(`api/TextLibrary/code/${startParam}/${code}/${lang}`, window._env_?.REACT_APP_API_BASE_URL)
}
